/**
 * Subscription Routes
 *
 * Routes for subscription upgrade and management.
 */
import React from 'react';
import { createRoute } from '@tanstack/react-router';
import { createPermissionBeforeLoad } from '@bb/session-manager';
import { authLayoutRoute } from '../rootRoute';
import * as groups from '../../groups.config';

const SubscriptionUpgradePage = React.lazy(() =>
  import('../../pages/Subscription/SubscriptionUpgradePage').then((m) => ({ default: m.SubscriptionUpgradePage }))
);
const SubscriptionManagePage = React.lazy(() =>
  import('../../pages/Subscription/SubscriptionManagePage').then((m) => ({ default: m.SubscriptionManagePage }))
);

const accountAdminPermission = createPermissionBeforeLoad({
  permissions: [groups.ACCOUNT_ADMIN_PERMISSION],
  forbiddenPath: '/bbweb/home',
});

export const subscriptionUpgradeRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/subscription/upgrade',
  beforeLoad: accountAdminPermission,
  component: SubscriptionUpgradePage,
});

export const subscriptionManageRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: '/subscription/manage',
  beforeLoad: accountAdminPermission,
  component: SubscriptionManagePage,
});

export const subscriptionRoutes = [subscriptionUpgradeRoute, subscriptionManageRoute];
